import React, { Children } from 'react';
import { motion } from 'framer-motion';
const GOLD = '#d8b878';
export function WhatIsEbook() {
  return <section className="relative overflow-hidden bg-matrix-black py-24 md:py-36 px-6 md:px-8" data-id="element-369">
      {/* Fine digital texture — faint vertical code columns + subtle noise */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.05]" style={{
      backgroundImage: 'repeating-linear-gradient(90deg, rgba(0,255,65,0.6) 0px, rgba(0,255,65,0.6) 1px, transparent 1px, transparent 9px), radial-gradient(rgba(216,184,120,0.5) 0.5px, transparent 0.5px)',
      backgroundSize: '9px 100%, 7px 7px',
      maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)'
    }} data-id="element-370"></div>

      {/* Depth + vignette */}
      <div className="pointer-events-none absolute inset-0 z-0" data-id="element-371">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,255,65,0.05)_0%,_transparent_60%)]" data-id="element-372"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_42%,_rgba(0,0,0,0.78)_100%)]" data-id="element-373"></div>
      </div>

      {/* Minimal system fragments drifting near the crack */}
      <div className="pointer-events-none absolute inset-0 z-0 hidden sm:block" data-id="element-374">
        {[{
        left: '46%',
        top: '30%',
        delay: 0
      }, {
        left: '54%',
        top: '62%',
        delay: 1.2
      }, {
        left: '49%',
        top: '48%',
        delay: 0.6
      }].map((p, i) => <motion.span key={i} className="absolute h-[3px] w-[3px] rounded-full" style={{
        left: p.left,
        top: p.top,
        backgroundColor: GOLD,
        boxShadow: '0 0 8px rgba(216,184,120,0.8)'
      }} animate={{
        opacity: [0, 0.7, 0],
        y: [0, -16, 0]
      }} transition={{
        duration: 6,
        delay: p.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-375" />)}
      </div>

      {/* Soft transition into the next section */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 z-0 h-24 bg-gradient-to-t from-matrix-dark to-transparent" data-id="element-376"></div>

      {/* The crack — an organic seam of light splitting the system open */}
      <div className="pointer-events-none absolute inset-0 z-0 flex items-stretch justify-center" data-id="element-377">
        {/* The system opening — a breathing oval of golden/green light */}
        <motion.div className="absolute left-1/2 top-1/2 h-[110%] w-[48vw] max-w-3xl -translate-x-1/2 -translate-y-1/2 blur-3xl" style={{
        background: 'radial-gradient(ellipse at center, rgba(216,184,120,0.20) 0%, rgba(0,255,65,0.06) 38%, transparent 70%)'
      }} animate={{
        opacity: [0.5, 0.92, 0.5],
        scaleX: [0.94, 1.06, 0.94]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-378" />

        {/* Organic jagged crack drawn as an SVG, with soft glow */}
        <motion.svg className="relative h-full w-[120px] md:w-[160px]" viewBox="0 0 160 1000" preserveAspectRatio="none" fill="none" animate={{
        opacity: [0.75, 1, 0.75]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-379">
          <defs data-id="element-380">
            <linearGradient id="crackGrad" x1="0" y1="0" x2="0" y2="1" data-id="element-381">
              <stop offset="0%" stopColor="rgba(255,245,215,0)" data-id="element-382" />
              <stop offset="16%" stopColor="rgba(255,245,215,0.9)" data-id="element-383" />
              <stop offset="50%" stopColor="#d8b878" data-id="element-384" />
              <stop offset="84%" stopColor="rgba(255,245,215,0.9)" data-id="element-385" />
              <stop offset="100%" stopColor="rgba(255,245,215,0)" data-id="element-386" />
            </linearGradient>
            <filter id="crackGlow" x="-200%" y="-50%" width="500%" height="200%" data-id="element-387">
              <feGaussianBlur stdDeviation="6" result="blur" data-id="element-388" />
              <feMerge data-id="element-389">
                <feMergeNode in="blur" data-id="element-390" />
                <feMergeNode in="SourceGraphic" data-id="element-391" />
              </feMerge>
            </filter>
          </defs>
          {/* Main organic fracture line */}
          <path d="M80 0 L74 120 L88 250 L70 380 L90 520 L66 650 L86 780 L76 900 L80 1000" stroke="url(#crackGrad)" strokeWidth="2.5" strokeLinecap="round" filter="url(#crackGlow)" data-id="element-392" />
          {/* Small branching fractures */}
          <path d="M88 250 L112 300 M70 380 L46 430 M90 520 L116 560 M66 650 L42 700 M86 780 L110 820" stroke="rgba(216,184,120,0.45)" strokeWidth="1" strokeLinecap="round" filter="url(#crackGlow)" data-id="element-393" />
        </motion.svg>

        {/* Faint inner green echo running down the fracture */}
        <div className="absolute inset-y-0 left-1/2 w-[10px] -translate-x-1/2 bg-[linear-gradient(180deg,transparent,rgba(0,255,65,0.12),transparent)] blur-[3px]" data-id="element-394"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-395">
        {/* Eyebrow */}
        <motion.span initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-7" style={{
        color: 'rgba(216,184,120,0.7)'
      }} data-id="element-396">
          Grieta en el sistema
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.05
      }} className="font-cinzel text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-matrix-cream leading-[1.25] mb-10 md:mb-12 drop-shadow-[0_0_18px_rgba(245,230,200,0.15)]" data-id="element-397">
          La vida que te enseñaron no siempre es la vida que elegiste
        </motion.h2>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.12
          }
        }
      }} className="space-y-5 md:space-y-6 text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9]" data-id="element-398">
          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} data-id="element-399">
            Desde que naciste, alguien empezó a decirte cómo pensar, qué temer,
            qué desear, qué perseguir y qué significaba “tener éxito”.
          </motion.p>
          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} data-id="element-400">
            Con el tiempo, muchas de esas ideas se convirtieron en una
            programación invisible.
          </motion.p>
          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} className="text-matrix-white/65" data-id="element-401">
            Trabajas. Cumples. Consumes. Te distraes. Repites patrones. Sigues
            adelante.
          </motion.p>
          <motion.p variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} data-id="element-402">
            Y aunque por fuera todo parezca normal, por dentro puede aparecer
            una pregunta silenciosa:
          </motion.p>
        </motion.div>

        {/* Emotional peak — the question that breaks the system */}
        <motion.p initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="font-cinzel italic font-bold text-3xl sm:text-4xl md:text-5xl my-12 md:my-16" style={{
        color: GOLD,
        textShadow: '0 0 24px rgba(216,184,120,0.7), 0 0 50px rgba(216,184,120,0.45), 0 0 90px rgba(216,184,120,0.25)'
      }} data-id="element-403">
          ¿Y si esto no es todo?
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9] max-w-xl mx-auto" data-id="element-404">
          Ese momento no es casualidad. Puede ser el inicio de una nueva forma
          de verte, entenderte y observar el tablero completo.
        </motion.p>
      </div>
    </section>;
}